export interface Columns {
  label: string | React.ReactNode
  name: string
  sortable?: boolean
  propertyId?: string
}

export enum SortTypes {
  asc = "asc",
  desc = "desc"
}

export type Sorting = {
  sortBy: string
  order: SortTypes
}
